/** True when `url` uses HTTPS and is parseable. */
export const isHttpsUrl = (url: string): boolean =>
  url.startsWith("https://") && URL.canParse(url);

/** Opens a validated HTTPS preview URL in a new tab; returns false when the URL is rejected. */
export const previewPdfInNewTab = (url: string): boolean => {
  if (!isHttpsUrl(url)) {
    return false;
  }

  window.open(url, "_blank");
  return true;
};
